import initialState from "./initialState";
import * as types from "../actions/actionTypes";
import { JobsState } from "../types/reduxState";

interface appActions {
  type: string;
  payload: any;
}

export default function b2bReducer(currentState: JobsState, action: appActions): any {
  const state = currentState || initialState.b2b;
  switch (action.type) {
    case types.SET_SKIPPED_JOBS:
      return {
        ...state,
        skipped: action.payload,
      };

    case types.SET_B2B_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.payload,
      };

    case types.SET_USER_COMPANY_DETAILS:
      return {
        ...state,
        companyDetails: action.payload,
      };

    case types.CLEAR_USER_COMPANY_DETAILS:
      return {
        ...state,
        companyDetails: null,
      };

    case types.SET_CLIENT_JOB_DETAILS:
      return {
        ...state,
        clientJobDetails: action.payload,
      };

    case types.SET_B2B_JOB_DETAILS:
      return {
        ...state,
        b2bJobDetails: action.payload,
      };

    case types.SET_B2B_JOB_APPLICANTS:
      return {
        ...state,
        b2bJobApplicants: action.payload,
      };

    case types.SET_APPLICANT_DETAILS:
      return {
        ...state,
        applicantDetails: action.payload,
        applicantDetailsLoading: false,
      };

    case types.SET_APPLICANT_DETAILS_LOADING:
      return {
        ...state,
        applicantDetailsLoading: action.payload,
      };

    case types.CLEAR_APPLICANT_DETAILS:
      return {
        ...state,
        applicantDetails: {},
        applicantDetailsLoading: false,
      };

    case types.VALIDATE_SHARE_LINK:
      return {
        ...state,
        shareLinkValidation: action.payload,
      };

    case types.VALIDATE_SHARE_PASSWORD:
      return {
        ...state,
        sharePasswordValidation: action.payload,
      };

    case types.SET_COMMENTS:
      return {
        ...state,
        comments: action.payload,
      };

    case types.SET_APPLICANT_REPORT:
      return {
        ...state,
        applicantReport: action.payload,
      };

    case types.SET_APPLICANT_PERSONALITY:
      return {
        ...state,
        applicantPersonality: action.payload,
      };

    case types.SET_APPLICANT_TOPIC_SCORE:
      return {
        ...state,
        applicantTopicScore: action.payload,
      };

    case types.SET_APPLICANT_SCORE_BAND:
      return {
        ...state,
        applicantScoreBand: action.payload,
      };

    case types.SET_PERSONALITY:
      return {
        ...state,
        personalities: action.payload,
      };

    case types.SET_FUNCTION_PERSONALITY:
      return {
        ...state,
        functionPersonalities: action.payload,
      };

    case types.UPDATE_BEST_FIT_STATUS:
      const { applicationId, isBestFit } = action.payload;
      // Update the best fit status in the applicants list
      const updatedApplicants = { ...(state as any).b2bJobApplicants };
      if (updatedApplicants.records) {
        updatedApplicants.records = updatedApplicants.records.map((applicant: any) => 
          applicant.applicationId === applicationId 
            ? { ...applicant, isBestFit }
            : applicant
        );
      }
      return {
        ...state,
        b2bJobApplicants: updatedApplicants,
      };

    case types.SET_ORG_ACCOUNT_SETTLEMENTS:
      return {
        ...state,
        orgAccountSettlements: action.payload,
      };

    default:
      return state;
  }
}
